"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListState = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const types_1 = require("./types");

let paginationId = 0;

class ListState {
  /** Constructor for ListState model Objects. ListState supports list services that use other forms of paging than index paging. */
  constructor(options) {
    paginationId += 1;
    Object.assign(this, Object.assign({
      filterQuery: '',
      filterQueryKeys: [],
      filterQueryMinLength: 3,
      pageNumber: 1,
      pageSize: types_1.MODEL_LIST_CONSTANTS.LIST_DEFAULT_PAGE_SIZE,
      paginationId: `paginationId${paginationId}`,
      sortKey: '',
      sortReverse: false
    }, options));
  }
  /** Returns true if `filterQuery` is empty or a property in the given item (any of the `filterQueryKeys`) matches `filterQuery`, case insensitively. */


  caseInsensitiveFilter(item) {
    return !this.filterQuery || // Return all results when there is no query
    this.filterQueryKeys.some(key => {
      var _a;

      const toLowerValue = (_a = item[key]) === null || _a === void 0 ? void 0 : _a.toLowerCase();
      return !!(toLowerValue === null || toLowerValue === void 0 ? void 0 : toLowerValue.includes(this.filterQuery.toLowerCase()));
    });
  }
  /** Sets the `filterQuery` property and resets the page number to 1. */


  setFilterQuery(filterQuery) {
    this.filterQuery = filterQuery;
    this.setPageNumber(1);
  }
  /** Sets the `pageNumber` property. */


  setPageNumber(pageNumber) {
    this.pageNumber = pageNumber;
  }
  /** Sets the `pageSize` property and resets the page number to 1. */


  setPageSize(pageSize) {
    this.pageSize = pageSize;
    this.setPageNumber(1);
  }
  /** Sets the `sortKey` property and will reverse the sort order if the given `sortKey` matches the internal `sortKey`. */


  setSortKeyAndReverseIfSameKey(sortKey) {
    this.sortReverse = sortKey === this.sortKey ? !this.sortReverse : false;
    this.sortKey = sortKey;
  }

}

exports.ListState = ListState;
exports.default = ListState;